var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRequestIncoming = function SvgRequestIncoming(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 34 37"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.04 18.321A9.5 9.5 0 0 1 24.5 18c1.235 0 2.415.236 3.497.664A13.5 13.5 0 0 0 28.5 15c0-7.456-6.044-13.5-13.5-13.5S1.5 7.544 1.5 15c0 3.215 1.124 6.167 3 8.485 1.47-3.863 4.404-6.688 7.9-7.638a5.5 5.5 0 1 1 5.202 0c1.63.443 3.141 1.295 4.439 2.474m6.876.766A9.5 9.5 0 0 1 24.5 37c-4.561 0-8.372-3.214-9.29-7.501a15 15 0 0 1-.47-.001l-.24.002c-2.676 0-5.24-.843-7.48-2.391C3.092 24.514.5 20.059.5 15 .5 6.992 6.992.5 15 .5S29.5 6.992 29.5 15c0 1.42-.204 2.79-.584 4.087m-13.865 9.4a9.503 9.503 0 0 1 5.887-9.796C19.227 17.295 17.171 16.5 15 16.5c-4.3 0-8.127 3.115-9.726 7.783a14.5 14.5 0 0 0 2.302 1.994 13.43 13.43 0 0 0 7.164 2.22q.156-.003.31-.01M15 15.5a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#FFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M22.633 24.504 19 27.518l3.633 2.986M19.5 27.5H30"
  })));
};
export default SvgRequestIncoming;